export const commonVariable =  {
    client_id : 'TTCNTT-SMARTSALES'
}